
import {
    GET_USER_TRANSITION_START,
    GET_USER_TRANSITION_SUCCESS,
    GET_USER__TRANSITION_FILED,
} from "../action-types/actionTypes";


const initialState = {
    loading: false,
    userTrPurchData: null,
    error: null,
  }

export function transitionPurchaseReducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_TRANSITION_START:
            return {
                ...state,
                loading: true
            }
        case GET_USER_TRANSITION_SUCCESS:
            return {
                ...state,
                loading: false,
                userTrPurchData: action.payload
            }
        case GET_USER__TRANSITION_FILED:
            return {
                ...state,
                loading: false,
                error: 'samething went wrong',
            }
        default:
            return state;
    }
}


